export class TransformUnionModel {
  constructor(public fields: UnionField[] = [], public tables: string[] = []) {}
}

export class UnionField {
  constructor(
    public key = '',
    public target = '',
    public source = '',
    public type = '',
    public display = true,
    public description = '',
    public source_alias = '',
  ) {}
}
